import {
  Component,
  ElementRef,
  Input,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import { ServiceLocatorService } from '@ncs/ncs-lib';
import { ActivatedRoute } from '@angular/router';

import { UsecaseBaseComponent } from '../usecase-base/usecase-base.component';

@Component({
  selector: 'app-usecase-chart',
  templateUrl: './usecase-chart.component.html',
  styleUrls: ['./usecase-chart.component.scss'],
})
export class UsecaseChartComponent extends UsecaseBaseComponent {
  @Input() custom: boolean = false;

  public loading: boolean = false;

  @ViewChild('content')
  content!: ElementRef;
  public filteredAttributes: any = [];

  public cachedChartData: { [key: string]: any } = {}; // Cache to store chart data

  constructor(
    public override locator: ServiceLocatorService,
    public override route: ActivatedRoute
  ) {
    super(locator, route);
    let _self = this;

    if (route.snapshot.paramMap.get('usecaseId'))
      _self.usecaseId = Number(route.snapshot.paramMap.get('usecaseId'));

    _self.locator.config
      .getProperty('endpoint.userstory')
      .then((property: string) => {
        _self.initApiEndpoint(property);
      });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['usecaseId']) {
      this.ngOnInit(); // Call ngOnInit or relevant method only if uiformId changes
    }
  }

  override ngOnInit() {
    let _self = this;
    if (_self.usecaseId) {
      _self.getUsecaseSchema(true, () => {
        console.log(_self);
        _self.filteredAttributes = _self.usecaseAttributes;
      });
    }
  }

  resetSearchValues() {
    this.form.data.field = '';
  }

  public filterAttributes(): any {
    const allowedTypes = [
      'text',
      'date',
      'number',
      'object',
      'email',
      'time',
      'url',
      'map',
      'textarea',
      'list',
      'expression',
    ];
    return this.usecaseAttributes.filter((e: any) =>
      allowedTypes.includes(e['type'])
    );
  }

  public drawChart() {
    let _self = this;
    //_self.loading = true;
    let code = this.form.data.field;
    if (code === undefined || code === '') {
      _self.filteredAttributes = _self.usecaseAttributes;
      return;
    }

    setTimeout(() => {
      let fields = _self.usecaseAttributes.filter((e: any) => e.code === code);
      _self.filteredAttributes = _self.usecaseAttributes.filter(
        (attribute: any) => attribute.code === code && code !== 'undefined'
      );
      //_self.loading = false;
    }, 100);
  }
}
